import { TFunction } from 'react-i18next';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { MenuItemOption } from 'ui/menu';
import { JOBS_TABLE_COLUMNS, JOBS_TABLE_COLUMN_DATA, TABLE_FILTER } from '../types';
import { JOB_STATE, JOB_TYPE } from '../types/jobs';

export const getJobManagerColumnData = (t: TFunction): JOBS_TABLE_COLUMN_DATA[] => [
  {
    id: JOBS_TABLE_COLUMNS.JOB_ID,
    label: t('table.header.jobId'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.JOB_NAME,
    label: t('table.header.name'),
    isSortable: false,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.JOB_TYPE_NAME,
    label: t('table.header.type'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.JOB_STATE,
    label: t('table.header.status'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.ORG_ID,
    label: t('table.header.orgId'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.PROJECT_ID,
    label: t('table.header.projectId'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.RECURRING,
    label: t('table.header.recurring'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.SCHEDULED_START_TIME,
    label: t('table.header.startTime'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: JOBS_TABLE_COLUMNS.END_TIME,
    label: t('table.header.endTime'),
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
];

type GetJobManagerTableFilterOptions = {
  t: TFunction;
  hasJobStatusSelected: boolean;
  hasJobTypeSelected: boolean;
};

export const getJobManagerTableFilterOptions = ({
  t,
  hasJobStatusSelected,
  hasJobTypeSelected,
}: GetJobManagerTableFilterOptions): MenuItemOption[] => [
  {
    hasCountBadge: hasJobStatusSelected,
    hasFilter: true,
    id: TABLE_FILTER.JOB_STATES,
    label: t('table.filter.jobStatus') ?? '',
    options: [
      {
        id: `${TABLE_FILTER.JOB_STATES}-${JOB_STATE.ENQUEUED}`,
        label: t(`jobStatus.${JOB_STATE.ENQUEUED}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_STATES}-${JOB_STATE.RUNNING}`,
        label: t(`jobStatus.${JOB_STATE.RUNNING}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_STATES}-${JOB_STATE.COMPLETED}`,
        label: t(`jobStatus.${JOB_STATE.COMPLETED}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_STATES}-${JOB_STATE.FAILED}`,
        label: t(`jobStatus.${JOB_STATE.FAILED}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_STATES}-${JOB_STATE.CANCELLING}`,
        label: t(`jobStatus.${JOB_STATE.CANCELLING}`) ?? '',
      },
    ],
  },
  {
    hasCountBadge: hasJobTypeSelected,
    hasFilter: true,
    id: TABLE_FILTER.JOB_TYPE_NAMES,
    label: t('table.filter.jobType') ?? '',
    options: [
      {
        id: `${TABLE_FILTER.JOB_TYPE_NAMES}-${JOB_TYPE.EXPORT_JOB}`,
        label: t(`jobType.${JOB_TYPE.EXPORT_JOB}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_TYPE_NAMES}-${JOB_TYPE.USER_RECORD_ANALYSIS_JOB}`,
        label: t(`jobType.${JOB_TYPE.USER_RECORD_ANALYSIS_JOB}`) ?? '',
      },
      {
        id: `${TABLE_FILTER.JOB_TYPE_NAMES}-${JOB_TYPE.TEST_JOB}`,
        label: t(`jobType.${JOB_TYPE.TEST_JOB}`) ?? '',
      },
    ],
  },
];
